export default __webpack_public_path__ + "static/media/1359.5f7c2693.png";